module.exports = __webpack_public_path__ + "img/ai-task-tabular-classification.3851e7e4.svg";